/** CareDock is a platform brand, not the legal identity of a provider tenant. */
export function publicBrandForHost(hostname) {
  const host = typeof hostname === 'string'
    ? hostname.trim().toLowerCase().replace(/\.$/, '')
    : '';
  // Explicit, exact Railway preview hostname. Never enable branding for a wildcard
  // or redirect preview users to live tenant services.
  const previewHostname = (process.env.REACT_APP_CAREDOCK_PREVIEW_HOST || '')
    .trim().toLowerCase().replace(/\.$/, '');
  const isPreview = previewHostname.endsWith('.up.railway.app') && host === previewHostname;
  const isCareDock = host === 'app.caredock.co.uk' || isPreview;
  return isCareDock
    ? { isCareDock, isPreview, name: 'CareDock', heading: 'CareDock', monogram: 'C', wordmark: '/caredock-wordmark.svg',
        tagline: 'The operating system for care providers.' }
    : { isCareDock, isPreview, name: 'Osabea CareOps', heading: 'CareOps', monogram: 'O', wordmark: null, tagline: null };
}
export function currentPublicBrand() {
  return publicBrandForHost(typeof window === 'undefined' ? '' : window.location.hostname);
}
